module.exports = __webpack_public_path__ + "static/media/SPG.fc5f21fc.svg";